import React from 'react';
import {
    Basket_Icon,
    Header_Menu_Next_Icon, Header_Menu_Sofa_Icon,
    Header_Menu_Washer_Icon,
    Menu_Checkbox_Icon,
    Menu_Icon,
    Search_Icon
} from "../Icon";
import {Link} from "react-router-dom";
import logo from "./../../../resources/images/logo.png"

export const Menu = (props) => {

    return (
        <div>
            <div className="header-block">
                <div className="container">
                    <div className='row header-menu'>
                        <div className="col-md-3 my-auto">
                            <img src={logo} alt="" className="header-menu_img__logo ml-4"/>
                        </div>
                        <div className="col-md-7">
                            <div className="input-group header-menu_div__search-block mt-3">
                                <input type="text" className="form-control" placeholder="Search"/>
                                <i className="fa fa-search header-menu_div__search-block_i"></i>
                            </div>
                        </div>
                        <div className="col-md-2 mt-2">
                            <div className="header-menu__basketIcon">
                                <div className="text-right">
                                    <div className="header-menu__basketIcon_div__savat">
                                        <button className="header-menu__basketIcon_div__savat_svg" id="header-menu__basketIcon_div__savat_svg">
                                            <Basket_Icon/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="">
                <div className="header-menu__section py-1">
                    <div className={"container"}>
                        <div className="row">
                            <div className="col-md-3">
                                <ul className="my-auto header-menu_ul__dropdown pl-0">
                                    <div className="btn text-left header-menu_button__click"
                                         id="dropdownMenuLink">
                                        <span className="header-menu__menuIcon">
                                            <i className="fa fa-bars"></i>
                                        </span>
                                        <span className="header-menu__nameSections">
                                            Категории
                                        </span>
                                        <span>
                                            <i className="fa fa-angle-down mt-1"></i>
                                        </span>
                                    </div>
                                    <ul className="header-menu_ul__SecondDropdown" id="header-menu_ul__SecondDropdown">
                                        <li className="header-menu_li__dropdown py-2">
                                            <div className="row">
                                                <span className="col-9">
                                                    <Link to="/category" className="header-menu_span__Name pr-0">Maishiy texnikalar</Link>
                                                </span>
                                                <span className="header-menu_span__NextIcon col-3">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                            </div>
                                            <ul className="header-menu_ul__SecondDropdown">
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="header-menu_li__dropdown py-2">
                                            <div className="row">
                                                <span className="col-9">
                                                    <Link to="/category" className="header-menu_span__Name pr-0">Maishiy texnikalar</Link>
                                                </span>
                                                <span className="header-menu_span__NextIcon col-3">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                            </div>
                                            <ul className="header-menu_ul__SecondDropdown header-menu_ul__ThirdDropdown">
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="header-menu_li__dropdown py-2">
                                            <div className="row">
                                                <span className="col-9">
                                                    <Link to="/category" className="header-menu_span__Name pr-0">Maishiy texnikalar</Link>
                                                </span>
                                                <span className="header-menu_span__NextIcon col-3">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                            </div>
                                            <ul className="header-menu_ul__SecondDropdown header-menu_ul__FourthDropdown">
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="header-menu_li__dropdown py-2">
                                            <div className="row">
                                                <span className="col-9">
                                                    <Link to="/category" className="header-menu_span__Name pr-0">Maishiy texnikalar</Link>
                                                </span>
                                                <span className="header-menu_span__NextIcon col-3">
                                                    <i className="fa fa-angle-right"></i>
                                                </span>
                                            </div>
                                            <ul className="header-menu_ul__SecondDropdown header-menu_li__FifthDrobdown">
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                                <li className="header-menu_li__dropdown py-2">
                                                    <div className="row">
                                                        <span className="col-9">
                                                            <Link to="/category" className="header-menu_span__SecondName pr-0">
                                                                Maishiy texnikalar
                                                            </Link>
                                                        </span>
                                                        <span className="col-3 header-menu_span__SecondNextIcon">
                                                            <i className="fa fa-angle-right"></i>
                                                        </span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </ul>
                            </div>
                            <div className="col-md-9 pt-1">
                                <div className="row">
                                    <div className="col">
                                        <Link to="" className="header-menu__menuLink px-3">
                                            <p>Новинки</p>
                                        </Link>
                                        <Link to="" className="header-menu__menuLink px-3">
                                            <p>Скидки</p>
                                        </Link>
                                        <Link to="" className="header-menu__menuLink px-3">
                                            <p>Красота</p>
                                        </Link>
                                        <Link to="" className="header-menu__menuLink px-3">
                                            <p>Одежда</p>
                                        </Link>
                                        <Link to="" className="header-menu__menuLink px-3">
                                            <p>Дом</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                    <div className="header-menu_basket_product_div w-25 pb-4" id="header-menu_basket_product_div">
                        <div className="row p-2 pt-3">
                            <div className="col-4 header-menu_basket_product_div__imgSection pr-0">
                                <img src="https://wp.toko.uz/wp-content/uploads/2020/12/52759_rdbk_1-300x300.jpg" alt=""/>
                            </div>
                            <div className="col-6 p-0 header-menu_basket_product_div__infoSection">
                                <Link className="header-menu_basket_product_div__infoSection_Link">мокасины - solar fuse</Link>
                                <div><span className="header-menu_basket_product_div__infoSection_worth1">1 × </span><span className="header-menu_basket_product_div__infoSection_worth2">925 000 сум</span></div>
                            </div>
                            <div className="col-2 p-0">
                                <button className="mt-2 ml-2 header-menu_basket_product_div__closeIcon_button">
                                    <i className="fa fa-times header-menu_basket_product_div__closeIcon"></i>
                                </button>
                            </div>
                        </div>
                        <hr className="mb-0"/>
                        <div className="row p-3 pt-0">
                            <div className="col-6">
                                <p className="mb-0 header-menu_basket_product_infoCost">Подытог</p>
                                <p className="mb-0 header-menu_basket_product_infoCost">Доставка</p>
                                <p className="mb-0 header-menu_basket_product_infoCost">Итого</p>
                            </div>
                            <div className="col-6 text-right">
                                <p className="mb-0 header-menu_basket_product_Cost">925 000 сум</p>
                                <p className="mb-0 header-menu_basket_product_Cost">0 сум</p>
                                <p className="mb-0 header-menu_basket_product_Cost">925 000 сум</p>
                            </div>
                        </div>
                        <div className="px-3">
                            <span>
                                <Link to="/savat">
                                    <button className="header-menu_basket_product_Cost_button1">Корзина</button>
                                </Link>
                            </span>
                            <span>
                                <Link to="/checkout">
                                    <button className="ml-2 header-menu_basket_product_Cost_button2">Оформить</button>
                                </Link>
                            </span>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
}